import React, {Component} from 'react'
import {observer, inject} from 'mobx-react'
import Meter from './Meter'
@inject("uiState") @observer
class MeterBinder extends Component{

  render(){
    const {meterValue} = this.props.uiState
    return <Meter value={meterValue}></Meter>
  }
}
export default MeterBinder



// WEBPACK FOOTER //
// ./src/topModule/MeterBinder.js